import styled, { css } from 'styled-components'
import { transparentize } from 'polished'
import media from 'styled-media-query'

const iconSize = '50px'
const purple = transparentize(0.4, 'purple')

export const StepIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  content: counter(steps);
  width: ${iconSize};
  height: ${iconSize};
  padding: 10px;
  border-radius: 100%;
  background: ${transparentize(0.4, 'purple')};
  color: white;
  margin-right: 1rem;
  transition: 0.2s all;
  svg {
    width: 100%;
  }
`

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  transition: 0.2s all;
  transform-origin: left;
`

export const StepLabel = styled.div`
  display: flex;
  align-items: center;
  min-height: ${iconSize};
  font-size: 1.2rem;
  font-weight: 400;
  color: purple;
  transition: 0.2s all;
  transform-origin: left;
  &:before {
    content: '#' counter(steps);
    margin-right: 0.5rem;
  }
`

export const Step = styled.li`
  display: flex;
  flex-direction: row;
  counter-increment: steps;
  position: relative;

  &:hover ${StepIcon} {
    transform: scale(1.1);
  }

  &:hover ${StepLabel} {
    transform: scale(1.1);
  }

  &:not(:last-child):before {
    content: '';
    position: absolute;
    top: calc(${iconSize} + 1rem);
    left: ${parseInt(iconSize) / 2}px;
    bottom: 1rem;
    width: 2px;
    background: purple;
  }
`

export const Stepper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  ${media.greaterThan('medium')`${css`
    max-width: 50%;
    margin: 0 auto;
  `}`}
`
